import React, { useState } from 'react';
import { TileGroup, Tile } from 'components/layout/tiles';
import { useWizard, WizardStepLayout } from 'components/layout/wizards';
import { WORKER_TYPES, WORKER_TYPE_ICONS } from 'constants/workers';
import { BaseTextInput, InputLabel } from 'components/forms';

export default function WorkerTypeStep() {
  const { nextStep, data } = useWizard();
  const [name, setName] = useState(data.name || '');
  const [type, setType] = useState(data.type || null);

  const handleNext = () => {
    if (name && type) {
      nextStep({ name, type });
    }
  };

  return (
    <WizardStepLayout
      title="Create New Worker"
      description="Name your worker and choose its type."
      primaryAction={{
        label: 'Next',
        onClick: handleNext,
        disabled: !name || !type
      }}
    >
      <div className="space-y-6">
        <div>
          <InputLabel htmlFor="workerName">Worker Name</InputLabel>
          <div className="mt-2">
            <BaseTextInput
              id="workerName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Price Monitor"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-300 mb-2">
            Worker Type
          </label>
          <TileGroup>
            <Tile
              title="Parser Worker"
              description="Extract data from a website using regex or JSON path."
              icon={WORKER_TYPE_ICONS[WORKER_TYPES.PARSER]}
              selected={type === WORKER_TYPES.PARSER}
              onClick={() => setType(WORKER_TYPES.PARSER)}
            />
            <Tile
              title="Prebuild Worker"
              description="Select from a list of ready-to-use workers."
              icon={WORKER_TYPE_ICONS[WORKER_TYPES.PREBUILD]}
              selected={type === WORKER_TYPES.PREBUILD}
              onClick={() => setType(WORKER_TYPES.PREBUILD)}
            />
          </TileGroup>
        </div>
      </div>
    </WizardStepLayout>
  );
}
